import { render, staticRenderFns } from "./CaixaConferencia.vue?vue&type=template&id=61e27702&scoped=true"
import script from "./CaixaConferencia.vue?vue&type=script&lang=js"
export * from "./CaixaConferencia.vue?vue&type=script&lang=js"
import style0 from "./CaixaConferencia.vue?vue&type=style&index=0&id=61e27702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e27702",
  null
  
)

export default component.exports